export default "__VITE_ASSET__BDxDYHWd__"